const defaultState = {
    landingPageData: null,
};

export default function scanAndPay(state = defaultState, action) {
    switch (action.type) {
        case 'SET_LANDING_PAGE_DATA':
            return {
                ...state,
                landingPageData: action.payload,
            };
        default:
            return state;
    }
}
